// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/student-report/routes/StudentReport/components/StudentReport/components/Footer/Footer.scss
// module id = 813
// module chunks = 0